

/* Admin */
export const USER_LOGOUT = 'USER_LOGOUT'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const UPDATE_CUSTOM_USER_DATA = 'UPDATE_CUSTOM_USER_DATA'
export const  FETCH_ALL_SELLER_PICKUPS_LIST = 'FETCH_ALL_SELLER_PICKUPS_LIST'






export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';

export const FETCH_ADMIN_PRODUCTS = 'FETCH_ADMIN_PRODUCTS';
export const FETCH_ADMIN_PRODUCT = 'FETCH_ADMIN_PRODUCT';
export const UPDATE_ADMIN_PRODUCT = 'UPDATE_ADMIN_PRODUCT';
export const DELETE_ADMIN_PRODUCT = 'DELETE_ADMIN_PRODUCT';

export const FETCH_ALL_SELLERS_LIST = 'FETCH_ALL_SELLERS_LIST';
export const RESET_SELLERS_LIST = 'RESET_SELLERS_LIST';

export const FETCH_ALL_CONTRACTORS_LIST = 'FETCH_ALL_CONTRACTORS_LIST';
export const  FETCH_CONTRACTORS  = 'FETCH_CONTRACTORS';

export const FETCH_USER = 'FETCH_USER';
export const FETCH_USERS = 'FETCH_USERS';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const ADD_USER = 'ADD_USER';


export const UPLOAD_ADMIN_PRODUCT_IMAGE = 'UPLOAD_ADMIN_PRODUCT_IMAGE';
export const UPDATE_ADMIN_PRODUCT_IMAGE = 'UPDATE_ADMIN_PRODUCT_IMAGE';
export const DELETE_ADMIN_PRODUCT_IMAGE = 'DELETE_ADMIN_PRODUCT_IMAGE';
export const UPDATE_ADMIN_PRODUCT_IMAGES = 'UPDATE_ADMIN_PRODUCT_IMAGES';
export const ADD_SELECTED_PRODUCTS = 'ADD_SELECTED_PRODUCTS';
export const REMOVE_SELECTED_PRODUCTS = 'REMOVE_SELECTED_PRODUCTS';
export const CLEAR_SELECTED_PRODUCTS = 'CLEAR_SELECTED_PRODUCTS';


export const FETCH_SELLERS = 'FETCH_SELLERS';
export const DELETE_SELLER = 'DELETE_SELLER';
export const UPDATE_SELLER = 'UPDATE_SELLER';
export const ADD_SELLER = 'ADD_SELLER';
export const FETCH_SELLER = 'FETCH_SELLER';
export const ADD_SELECTED_SELLERS = 'ADD_SELECTED_SELLERS';
export const REMOVE_SELECTED_SELLERS = 'REMOVE_SELECTED_SELLERS';
export const CLEAR_SELECTED_SELLERS = 'CLEAR_SELECTED_SELLERS';

export const ADD_SELECTED_USERS = 'ADD_SELECTED_USERS';
export const REMOVE_SELECTED_USERS = 'REMOVE_SELECTED_USERS';
export const CLEAR_SELECTED_USERS = 'CLEAR_SELECTED_USERS';

export const FETCH_TRANSACTIONS = 'FETCH_TRANSACTIONS';
export const DELETE_TRANSACTION = 'DELETE_TRANSACTION';
export const UPDATE_TRANSACTION = 'UPDATE_TRANSACTION';
export const RESET_TRANSACTIONS = 'RESET_TRANSACTIONS';
export const ADD_TRANSACTION = 'ADD_TRANSACTION';
export const FETCH_TRANSACTION = 'FETCH_TRANSACTION';
export const ADD_SELECTED_TRANSACTIONS = 'ADD_SELECTED_TRANSACTIONS';
export const REMOVE_SELECTED_TRANSACTIONS = 'REMOVE_SELECTED_TRANSACTIONS';
export const CLEAR_SELECTED_TRANSACTIONS = 'CLEAR_SELECTED_TRANSACTIONS';
export const UPDATE_TRANSACTION_DATA = 'UPDATE_TRANSACTION_DATA';

export const UPDATE_APP_DATA = 'UPDATE_APP_DATA';

 export const FETCH_PRODUCT = 'FETCH_PRODUCT';
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';

export const FETCH_FOCUS_AREAS = 'FETCH_FOCUS_AREAS';
export const UPDATE_FOCUS_AREA = 'UPDATE_FOCUS_AREA';
export const ADD_FOCUS_AREA = 'ADD_FOCUS_AREA';
export const DELETE_FOCUS_AREA = 'DELETE_FOCUS_AREA';

export const FETCH_VEHO_ZIPCODES = 'FETCH_VEHO_ZIPCODES';
export const FETCH_METRO_AREAS = 'FETCH_METRO_AREAS';
export const FETCH_METRO_AREA = 'FETCH_METRO_AREA';

export const UPDATE_METRO_AREA = 'UPDATE_METRO_AREA';
export const ADD_METRO_AREA = 'ADD_METRO_AREA';
export const DELETE_METRO_AREA = 'DELETE_METRO_AREA';

export const FETCH_ADMIN_GBG_PRODUCTS = 'FETCH_ADMIN_GBG_PRODUCTS';
export const UPDATE_ADMIN_GBG_PRODUCT = 'UPDATE_ADMIN_GBG_PRODUCT';
export const DELETE_ADMIN_GBG_PRODUCT = 'DELETE_ADMIN_GBG_PRODUCT';
export const ADD_ADMIN_GBG_PRODUCT = 'ADD_ADMIN_GBG_PRODUCT';
export const ADD_SELECTED_GBG_PRODUCTS = 'ADD_SELECTED_GBG_PRODUCTS';
export const REMOVE_SELECTED_GBG_PRODUCTS = 'REMOVE_SELECTED_GBG_PRODUCTS';
export const CLEAR_SELECTED_GBG_PRODUCTS = 'CLEAR_SELECTED_GBG_PRODUCTS';

export const FETCH_ADMIN_USER_TIME_TRACKING = 'FETCH_ADMIN_USER_TIME_TRACKING';
  export const ADD_SELECTED_USER_TIME_TRACKING = 'ADD_SELECTED_USER_TIME_TRACKING';
export const REMOVE_SELECTED_USER_TIME_TRACKING = 'REMOVE_SELECTED_USER_TIME_TRACKING';
export const CLEAR_SELECTED_USER_TIME_TRACKING = 'CLEAR_SELECTED_USER_TIME_TRACKING';

export const FETCH_ADMIN_SUBSCRIPTIONS = 'FETCH_ADMIN_SUBSCRIPTIONS';
export const UPDATE_ADMIN_SUBSCRIPTION = 'UPDATE_ADMIN_SUBSCRIPTION';
export const DELETE_ADMIN_SUBSCRIPTION = 'DELETE_ADMIN_SUBSCRIPTION';
export const ADD_ADMIN_SUBSCRIPTION = 'ADD_ADMIN_SUBSCRIPTION';



export const FETCH_ADMIN_SERVICES = 'FETCH_ADMIN_SERVICES';
export const UPDATE_ADMIN_SERVICE = 'UPDATE_ADMIN_SERVICE';
export const DELETE_ADMIN_SERVICE = 'DELETE_ADMIN_SERVICE';
export const ADD_ADMIN_SERVICE = 'ADD_ADMIN_SERVICE';
export const ADD_SELECTED_SERVICES = 'ADD_SELECTED_SERVICES';
export const REMOVE_SELECTED_SERVICES = 'REMOVE_SELECTED_SERVICES';
export const CLEAR_SELECTED_SERVICES = 'CLEAR_SELECTED_SERVICES';

export const FETCH_ADMIN_ORDERS = 'FETCH_ADMIN_ORDERS';
export const FETCH_ADMIN_PALLETS = 'FETCH_ADMIN_PALLETS';
export const FETCH_ADMIN_PROMOCODES = 'FETCH_ADMIN_PROMOCODES';


export const FETCH_SELLER_SERVICES = 'FETCH_SELLER_SERVICES';
export const UPDATE_SELLER_SERVICE = 'UPDATE_SELLER_SERVICE';


